import React, { useEffect } from 'react'
import { CssBaseline, GlobalStyles } from '@mui/material'
import CustomStyles from './style'

import 'react-quill/dist/quill.snow.css'
import './customQuillStyle.css'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import '@fontsource/inter/100.css'
import '@fontsource/inter/200.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/inter/900.css'

import CacheBuster from 'react-cache-buster'
import { BUILD_VERSION } from './buildInfo'
import LoadingPage from './pages/LoadingPage'
import AppRoutes from './pages'
import '@aws-amplify/ui-react/styles.css'
import Providers from './components/Providers'
import { configureAmplify } from './utils/cognito'
import { Hub } from 'aws-amplify/utils'
import { SetupTourFeature } from './features/SetupWizardFeature'

dayjs.extend(utc)
dayjs.extend(timezone)

const userTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
dayjs.tz.setDefault(userTimeZone)

Hub.listen('core', ({ payload }) => {
  console.log(`core event: ${payload?.event}`)
})
Hub.listen('auth', ({ payload }) => {
  console.log(`auth event: ${payload?.event}`)
})

const tenantInfo = localStorage.getItem('tenantInfo')

if (tenantInfo !== null) {
  const parsedTenantInfo = JSON.parse(tenantInfo)
  configureAmplify(parsedTenantInfo)
}

const App = (): JSX.Element => {
  const isProduction = process.env.NODE_ENV === 'production'

  return (
    <CacheBuster
      currentVersion={BUILD_VERSION}
      isEnabled={isProduction}
      isVerboseMode={false}
      loadingComponent={<LoadingPage />}
    >
      <Providers>
          <GlobalStyles styles={CustomStyles} />
          <CssBaseline />
          <AppRoutes />
          <SetupTourFeature />
      </Providers>
    </CacheBuster>
  )
}

export default App
